<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import TicketToolbar from "./show/TicketToolbar";
import TicketInterfaceWrapper from "./show/TicketInterfaceWrapper";
import TicketMainSection from "./show/TicketMainSection";
import TicketMainSectionLeftColumn from "./show/TicketMainSectionLeftColumn";
import TicketMainSectionRightColumn from "./show/TicketMainSectionRightColumn";
import TicketMainSectionSidebar from "./show/TicketMainSectionSidebar";

import {mapGetters, mapActions} from "vuex";

/**
 * View ticket component
 */
export default {
  page: {
    title: "Ticket Details",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    TicketToolbar,
    TicketInterfaceWrapper,
    TicketMainSection,
    TicketMainSectionLeftColumn,
    TicketMainSectionRightColumn,
    TicketMainSectionSidebar
  },
  data() {
    return {
      title: "Ticket Details",
      items: [
        {
          text: "Tickets",
          href: "/tickets"
        },
        {
          text: "Details",
          active: true
        }
      ]
    };
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadTicket: 'loadTicket',
      reloadTicket: 'reloadTicket',
      loadAgents: 'loadAgents'
    }),

    listenForTicketUpdatedEvent() {
      let vm = this;

      window.Echo.channel(this.echoChannelId).listen('TicketUpdated', (e) => {
        let emailOfAgentWhoTriggeredUpdate = e.emailOfAgentWhoTriggeredUpdate;
        // let emailOfLoggedInUser = this.$auth.user.email;
        let emailOfLoggedInUser = this.$auth.user.username;

        if (emailOfAgentWhoTriggeredUpdate !== emailOfLoggedInUser) {
          vm.reloadTicket();
          this.$notify.success({
            title: 'Live updated',
            message: 'Ticket was updated by another agent'
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters('ticketViewer', {
      isLoading: 'isLoading',
      ticket: 'ticket',
      updateKey: 'updateKey',
      timelineUpdateKey: 'timelineUpdateKey',
      sidebarSection: 'sidebarSection'
    }),

    echoChannelId() {
      return `tickets.${this.$route.params.id}`;
    }
  },
  created() {
    this.loadAgents();
    this.loadTicket(this.$route.params.id);
    this.listenForTicketUpdatedEvent();
  },
  watch: {
    $route() {
      this.loadTicket(this.$route.params.id);
    }
  }
};
</script>

<template>
  <Layout :full-width="true">
    <loading-screen :is-loading="isLoading"></loading-screen>
    <TicketInterfaceWrapper v-if="ticket">
      <ticket-toolbar></ticket-toolbar>

      <TicketMainSection>
        <TicketMainSectionLeftColumn :key="timelineUpdateKey"></TicketMainSectionLeftColumn>
        <TicketMainSectionRightColumn :key="updateKey"></TicketMainSectionRightColumn>
        <TicketMainSectionSidebar v-if="sidebarSection !== null"></TicketMainSectionSidebar>
      </TicketMainSection>
    </TicketInterfaceWrapper>
    <!-- end row -->
  </Layout>
</template>
